export default "__VITE_ASSET__Cvhtig4G__"